import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as r } from "react";
import { I as a } from "./icon-button-BxDvkq_l.mjs";
const f = r(({ ...o }, t) => /* @__PURE__ */ n.jsx(a, { floatingIcon: !0, ref: t, ...o, "data-fabric-component": "FloatingIconButton" }));
export {
  f as F
};
//# sourceMappingURL=floating-icon-button-CHJsoxe2.mjs.map
